import { BaseEntity } from ".";
import { IGet_characters_character_id_standings_200_ok } from "../service/esiclient";
import { StaticStorageClient } from "../service/staticstorageclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";

const staticStorageClient = new StaticStorageClient();
export class CharacterStandingsEntity extends BaseEntity {
  private _showAgents: boolean;
  constructor(id: number, props: any, show_agents: boolean) {
    super(id, props);
    this._dataTypeName = "Character Standings";
    this._showAgents = show_agents;
  }
  async toSingleValue(id: number) {
    let value = 0;
    for (const y of this.props) {
      if (y) {
        if (y.from_id == id) {
          value = y.standing;
        }
      }
    }
    return value;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const props: Partial<IGet_characters_character_id_standings_200_ok[]> = this.props;

    var entity = await super.toJson();
    let nameList = null;
    // Properties
    if (entity.properties) {
      if (props) {
        const characterEntity = await getCachedCharacterEntity(id);
        if (characterEntity != null) {
          entity.properties["owner"] = await characterEntity.toJson();
          entity.text = `Standings for ${characterEntity?.props.name.toString()}`;
        }
        let data_array: Excel.CellValue[][] = [];
        const numberOptions = { minimumFractionDigits: 0 };
        const bulkNames = [];
        for (const y of props) {
          if (y && (y.from_type == "agent" || y.from_type == "npc_corp")) {
            bulkNames.push(y.from_id);
          }
        }
        nameList = await staticStorageClient.get_names(bulkNames);

        for (const y of props) {
          if (y) {
            if (y.from_type === "faction") {
              const faction = await staticStorageClient.get_faction_by_id(y.from_id);
              if (faction !== null) {
                data_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: faction.factionName.toString() + ": " + y.standing.toLocaleString("en-GB", numberOptions),
                    properties: {
                      name: {
                        type: Excel.CellValueType.string,
                        basicValue: faction.factionName.toString(),
                      },
                      id: {
                        type: Excel.CellValueType.double,
                        basicValue: y.from_id,
                      },
                      standings: {
                        type: Excel.CellValueType.double,
                        basicValue: y.standing,
                      },
                      type: {
                        type: Excel.CellValueType.string,
                        basicValue: y.from_type,
                      },
                    },
                  },
                ]);
              } else {
                data_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: y.from_id + ": " + y.standing.toLocaleString("en-GB", numberOptions),
                    properties: {
                      name: {
                        type: Excel.CellValueType.string,
                        basicValue: "Unknown",
                      },
                      id: {
                        type: Excel.CellValueType.double,
                        basicValue: y.from_id,
                      },
                      standings: {
                        type: Excel.CellValueType.double,
                        basicValue: y.standing,
                      },
                      type: {
                        type: Excel.CellValueType.string,
                        basicValue: y.from_type,
                      },
                    },
                  },
                ]);
              }
            } else if (y.from_type === "npc_corp") {
              const nameToUse = nameList?.find((item) => item.id === y.from_id);
              const corpName = nameToUse;
              if (corpName !== null && corpName?.entityName) {
                data_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: corpName?.entityName.toString() + ": " + y.standing.toLocaleString("en-GB", numberOptions),
                    properties: {
                      name: {
                        type: Excel.CellValueType.string,
                        basicValue: corpName?.entityName.toString(),
                      },
                      id: {
                        type: Excel.CellValueType.double,
                        basicValue: y.from_id,
                      },
                      standings: {
                        type: Excel.CellValueType.double,
                        basicValue: y.standing,
                      },
                      type: {
                        type: Excel.CellValueType.string,
                        basicValue: y.from_type,
                      },
                    },
                  },
                ]);
              } else {
                data_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: y.from_id + ": " + y.standing.toLocaleString("en-GB", numberOptions),
                    properties: {
                      name: {
                        type: Excel.CellValueType.string,
                        basicValue: "Unknown",
                      },
                      id: {
                        type: Excel.CellValueType.double,
                        basicValue: y.from_id,
                      },
                      standings: {
                        type: Excel.CellValueType.double,
                        basicValue: y.standing,
                      },
                      type: {
                        type: Excel.CellValueType.string,
                        basicValue: y.from_type,
                      },
                    },
                  },
                ]);
              }
            } else if (y.from_type === "agent" && this._showAgents) {
              const nameToUse = nameList?.find((item) => item.id === y.from_id);
              const charName = nameToUse;
              if (charName !== null && charName?.entityName) {
                data_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: charName?.entityName.toString() + ": " + y.standing.toLocaleString("en-GB", numberOptions),
                    properties: {
                      name: {
                        type: Excel.CellValueType.string,
                        basicValue: charName?.entityName.toString(),
                      },
                      id: {
                        type: Excel.CellValueType.double,
                        basicValue: y.from_id,
                      },
                      standings: {
                        type: Excel.CellValueType.double,
                        basicValue: y.standing,
                      },
                      type: {
                        type: Excel.CellValueType.string,
                        basicValue: y.from_type,
                      },
                    },
                  },
                ]);
              } else {
                data_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: y.from_id + ": " + y.standing.toLocaleString("en-GB", numberOptions),
                    properties: {
                      name: {
                        type: Excel.CellValueType.string,
                        basicValue: "Unknown name",
                      },
                      id: {
                        type: Excel.CellValueType.double,
                        basicValue: y.from_id,
                      },
                      standings: {
                        type: Excel.CellValueType.double,
                        basicValue: y.standing,
                      },
                      type: {
                        type: Excel.CellValueType.string,
                        basicValue: y.from_type,
                      },
                    },
                  },
                ]);
              }
            }
          }
        }
        if (data_array.length) {
          entity.properties["standings"] = {
            type: Excel.CellValueType.array,
            elements: data_array,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
